import React from "react";
import { useTranslation } from "react-i18next";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import Grid from "@mui/material/Grid";

const TYPES = [
    { value: "Servicio", labelKey: "crm.products.service" },
    { value: "Producto", labelKey: "crm.products.product" },
    { value: "Cuenta",   labelKey: "crm.products.account" },
];

export const TypeSelector = ({ value, onChange }) => {
    const { t } = useTranslation();

    return (
        <Grid size={{ xs: 12 }}>
            <FormControl fullWidth>
                <FormLabel>{t("crm.products.type")}</FormLabel>
                <RadioGroup
                    row
                    value={value}
                    onChange={({ target }) => onChange("type", target.value)}
                >
                    {TYPES.map(({ value: v, labelKey }) => (
                        <FormControlLabel
                            key={v}
                            value={v}
                            control={<Radio />}
                            label={t(labelKey)}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Grid>
    );
};